import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import { HttpConnector } from '@/modules/shared/domain/connectors/http';
import TYPES from '@/types';
import { UserCredentialsType } from '@/modules/authentication/domain/types';
import { AuthenticationDataRepository } from '../../domain/repositories';

@Injectable()
export default class AuthenticationDataFetchRepository implements AuthenticationDataRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly path = `${process.env.VUE_APP_API_URL}/api/v1/app/auth/login/`;

  create(user_credentials: UserCredentialsType): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.path, 'POST', user_credentials)
        .then((response) => {
          response.json().then(({
            data,
            message,
            success,
          }) => {
            if (success) {
              resolve(data);
            } else {
              reject(new Error(message));
            }
          });
        })
        .catch(reject);
    });
  }
}
